import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldCheckboxMultiple = ({
  disabled,
  formField,
  onChange,
  value = []
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const {
    label,
    name,
    options,
    required
  } = formField;
  const isError = showAllErrors && required && !value.length;
  const fieldLabel = formField.label;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  const handleOnChange = (event, optionValue) => {
    const updatedValue = event.target.checked ? [...value, optionValue] : value.filter(checkboxValue => checkboxValue !== optionValue);
    onChange(syntheticEvent(updatedValue));
  };
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description ? formField.description : required ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.contactInfo.multiCheckboxHelper"
    }) : undefined,
    label: label,
    required: required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsx(ToggleGroup, {
      name: name,
      children: options.map(option => /*#__PURE__*/_jsx(Checkbox, {
        color: "icon-interactive-default",
        checked: value.includes(option.value),
        "data-test-id": "custom-form-field-checkbox-input-multiple",
        disabled: disabled,
        onChange: event => handleOnChange(event, option.value),
        children: option.label
      }, option.value))
    })
  });
};
export default CustomFormFieldCheckboxMultiple;